import React from 'react';

import styled from 'styled-components';
import TooltipInfo from 'components/TooltipInfo';

const Panel = styled.div`
  max-width: 420px;
  font-size: 0.85em;
  line-height: 1.45;
  color: ${({ theme }) => theme.colors.foreground.primary};
`;

const Heading = styled.div`
  font-weight: 600;
  margin-bottom: 4px;
`;

const Table = styled.table`
  border-collapse: collapse;
  margin: 6px 0;
  width: 100%;

  th,
  td {
    text-align: left;
    padding: 1px 8px 1px 0;
    white-space: nowrap;
  }

  td:last-child {
    text-align: right;
    padding-right: 0;
  }
`;

const Note = styled.p`
  margin: 6px 0 0;
  color: ${({ theme }) => theme.colors.foreground.tint};
`;

/**
 * Förklarar var kronbeloppen i luckväljaren kommer ifrån.
 *
 * Finns för att siffrorna annars ser exakta ut utan att vara det. De var länge rena
 * PLACEHOLDER-värden — koden sa det själv i en kommentar — och en trafikledare som väljer mellan
 * tåg och annons på 200 kronors skillnad förtjänar att veta hur de 200 kronorna räknats fram, och
 * vilka av dem som faktiskt är mätta.
 */
const SchablonInfo: React.FC = () => (
  <TooltipInfo
    closeOnLeave={false}
    focusable
    maxWidth$={440}
    nodeAlign="right"
    title="Så är beloppen framräknade"
    info={
      <Panel>
        <Heading>Så är beloppen framräknade</Heading>
        <p>
          Kostnaden för ett lucka-val är <strong>biljett + betald restid</strong>. Restiden räknas
          på schablontimlön inklusive sociala avgifter, eftersom persontransporten skapas som ett
          tilldelat uppdrag.
        </p>

        <Heading>Biljetten</Heading>
        <Table>
          <tbody>
            <tr>
              <td>Tåg och kollektivtrafik</td>
              <td>75 kr + 1,50 kr/km</td>
            </tr>
            <tr>
              <td>Buss</td>
              <td>60 kr</td>
            </tr>
            <tr>
              <td>Taxi</td>
              <td>900 kr</td>
            </tr>
            <tr>
              <td>Flyg</td>
              <td>1 200 kr</td>
            </tr>
            <tr>
              <td>Båt/färja</td>
              <td>300 kr</td>
            </tr>
            <tr>
              <td>Hotellnatt</td>
              <td>1 010 kr</td>
            </tr>
          </tbody>
        </Table>

        <p>
          <strong>Mätta mot verkliga utlägg</strong> (prod-kopian, 12 månader): tåg och
          kollektivtrafik är anpassade mot 3 040 rena tågresor och 5 494 kollektivtrafikresor, där
          uppdragets sträcka är själva resan. Hotellnatten är medianen av 3 251 utlägg, och 88,6 %
          av dem ligger mellan 500 och 1 499 kr. Bussen sänktes från 350 kr efter mätning.
        </p>

        <Note>
          <strong>Taxi, flyg och båt är fortfarande uppskattningar.</strong> Taxi går inte att mäta
          — det finns ett enda rent taxiuppdrag, och taxiutläggen på vanliga uppdrag beskriver
          sista biten av en lång körning snarare än hela resan. Flyg har 27 observationer, och
          färjor prissätts per överfart och inte per kilometer. Väg de tre beloppen som
          storleksordningar, inte som priser.
        </Note>
      </Panel>
    }
  />
);

export default SchablonInfo;
